import { PublicClientApplication } from '@azure/msal-browser';
import Cookies from 'js-cookie';

const { origin } = window.location;

// To add a new dev port: append { port: XXXX, name: 'Dev Name' }
const LOCALHOST_PORTS = [
  { port: 3000, name: 'Shared / Backend Fusion' },
  { port: 3001, name: 'Wes' },
  { port: 3002, name: 'MikeTec' },
  { port: 3003, name: 'Brenton' },
  { port: 3004, name: 'Noah' },
  { port: 3005, name: 'Joey' },
  { port: 3006, name: 'Sebastian' },
  { port: 3007, name: 'Jacob' },
  { port: 3008, name: 'Charles' },
];

// To add a new environment: append the subdomain — resolves to https://{subdomain}.overwatch.ai
// The 2026-08-15 decommission retired pittsburghpa, harrisonky, trial,
// gillespietx and williamsontx for good — do not re-add them.
const OVERWATCH_SUBDOMAINS = [
  'devdemo',
  'stagingdemo',
  'comaltx',
  'demo',
  'pro',
];

export const getRedirectUri = () => {
  const matchedPort = LOCALHOST_PORTS.find(({ port }) => origin.includes(`localhost:${port}`));
  if (matchedPort) return `http://localhost:${matchedPort.port}`;

  if (origin.includes('192')) return origin;

  const matchedSubdomain = OVERWATCH_SUBDOMAINS.find((sub) => origin.includes(sub));
  if (matchedSubdomain) return `https://${matchedSubdomain}.overwatch.ai`;

  return '';
};

export const configuration = {
  auth: {
    clientId: 'fc3e525d-dc3e-4aaf-a892-ab5d48134bfe',
    authority: 'https://login.microsoftonline.com/common',
    redirectUri: getRedirectUri(),
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true,
  },
};

const hasBrowserCryptoSupport = () => {
  if (typeof window === 'undefined') return false;
  const cryptoObject = window.crypto;
  return (
    !!cryptoObject &&
    typeof cryptoObject.getRandomValues === 'function' &&
    typeof cryptoObject.subtle?.digest === 'function'
  );
};

export const isMsalSupportedInBrowser = hasBrowserCryptoSupport();

export function SignOut() {
  Cookies.remove('msToken');
  window.location.href = '/';
}

export const pca = isMsalSupportedInBrowser
  ? new PublicClientApplication(configuration)
  : null;

/**
 * MSAL v3.x requires explicit initialization before use.
 * This promise resolves when the instance is ready for authentication calls.
 */
export const msalInitPromise = pca
  ? pca
      .initialize()
      .then(async () => {
        try {
          const response = await pca.handleRedirectPromise();
          if (response) {
            pca.setActiveAccount(response.account);
          }
        } catch (error) {
          console.error('[MSAL] handleRedirectPromise error:', error);
        }
      })
      .catch((error) => {
        console.error('[MSAL] Initialization failed:', error);
      })
  : Promise.resolve();
